import styled from 'styled-components'
import { themeGet } from 'styled-system'
import {
  ClassCardModalWrapperDelete,
  DeleteButton,
  DeleteMessageWrapper,
  ModalWrapperDelete,
} from '../Delete/component.styles'
import { ModalHeaderInput } from '../../component.styles'

const leaveMessageMargin = `
  ${DeleteMessageWrapper} {
    margin-bottom: calc(0.5rem + 14px);
  }
`

export const ModalWrapperLeave = styled(ModalWrapperDelete)`
  ${leaveMessageMargin}

  ${ModalHeaderInput} {
    color: ${themeGet('colors.themeSecondary')};
    font-family: ${themeGet('font.sharpSlab.extraBold')};
    font-size: 1.625rem;
    margin-bottom: calc(1rem + 4px);
    text-align: center;

    ${themeGet('breakpoints.mobile')} {
      margin-bottom: calc(1.25rem + 4px);
    }
  }
`

export const ClassCardModalWrapperLeave = styled(ClassCardModalWrapperDelete)`
  ${leaveMessageMargin}

  ${ModalHeaderInput} {
    color: ${themeGet('colors.secondStepBlue')};
    font-family: ${themeGet('font.sharpSlab.extraBold')};
    font-size: 1.625rem;
    margin-bottom: calc(0.75rem + 4px);
    text-align: center;

    ${themeGet('breakpoints.mobile')} {
      margin-bottom: calc(1rem + 4px);
    }
  }
`

export const LeaveButton = styled(DeleteButton)`
  background: ${props =>
    props.isDisabled
      ? themeGet('colors.gray650')(props)
      : themeGet('colors.buttons.primary.bgActive')(props)} !important;

  &:hover:not(:disabled) {
    background: ${props =>
      props.isDisabled
        ? themeGet('colors.gray650')(props)
        : themeGet('colors.buttons.secondary.bgHover')(props)} !important;
  }
`
